module.exports = __webpack_public_path__ + "img/emoji_31.b8db6cc8.png";